import { Component, ViewChild } from '@angular/core';
import { Pagination } from 'src/app/shared/models/pagination.model';
import { User } from 'src/app/shared/models/user.model';
import { Currency } from 'src/app/shared/models/currency.model';
import Swal from 'sweetalert2';
import { ReportService } from 'src/app/shared/service/report.service';
import { LazyLoadEvent } from 'primeng/api';
import { WithdrawModel } from 'src/app/shared/models/withdraw.model';
import { DateModel } from '../../../../../shared/models/date.model';
import { DateService } from '../../../../../shared/service/date.service';
import { DateFilterWithdrawCrypto } from '../../../../../core/models/date-filter-withdraw-crypto.entities';
import { DatepickerComponent } from '../../../../../shared/components/datepicker/datepicker.component';
import { TransferType } from '../../../../../shared/models/transfer-type.model';
import { SelectCurrencyComponent } from '../../../../../shared/components/select-currency/select-currency.component';
import { GiftCardComponent } from '../gift-card/gift-card.component';

@Component({
  selector: 'app-withdraw-crypto',
  templateUrl: './withdraw-crypto.component.html',
  styleUrls: ['./withdraw-crypto.component.scss']
})
export class WithdrawCryptoComponent {
  protected readonly TransferType = TransferType;

  @ViewChild('currencySelector') currencySelector: SelectCurrencyComponent;
  @ViewChild('startDateEl') startDateEl: DatepickerComponent;
  @ViewChild('endDateEl') endDateEl: DatepickerComponent;
  @ViewChild('giftCardComponent') giftCardComponent: GiftCardComponent;
  tableLoading = true;
  pagination: Pagination<WithdrawModel> = new Pagination<WithdrawModel>();
  createdGiftCardUserIds!: User[];
  loading = true;
  page = 1;
  limit = 15;
  includedUsers: User[] = [];
  selectedCurrency: Currency[] = [];
  dateFilter: DateFilterWithdrawCrypto = { startDate: '', endDate: '' };
  validationErrors$ = this.reportService.validationErrorsWithdrawCrypto$;

  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  constructor(private reportService: ReportService, private dateService: DateService) {}

  clearFilters() {
    this.startDateEl.clear();
    this.endDateEl.clear();
    this.dateFilter = { startDate: '', endDate: '' };
    this.currencySelector.deselectAll();
    this.getCryptoWithdrawList({ first: 0, rows: this.limit });
  }

  changeRecordPerPageLimit(limit: number): void {
    this.limit = limit;
    this.getCryptoWithdrawList({
      first: 0,
      rows: limit
    });
  }

  copy(text: string, alert: string): void {
    navigator.clipboard.writeText(text);
    this.Toast.fire({ icon: 'success', text: alert });
  }

  getCryptoWithdrawList(event: LazyLoadEvent = {}): void {
    this.loading = true;
    if (event.first !== undefined && event.rows !== undefined) {
      this.page = event?.first / this.limit + 1;
    }
    const currenciesId = this.selectedCurrency.map((currency) => currency.id);
    const userIds = this.includedUsers.map((user) => user.id);
    this.reportService
      .getCryptoWithdrawList(userIds, currenciesId, this.dateFilter, this.page, event.rows)
      .subscribe({
        next: (pagination) => {
          this.pagination = pagination;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });
  }

  report() {
    this.giftCardComponent.getGiftCardsList();
    this.getCryptoWithdrawList();
  }

  setStartDate(date: DateModel) {
    this.dateFilter.startDate = this.dateService.convertDateToStringGregorian(date);
  }

  setEndDate(date: DateModel) {
    this.dateFilter.endDate = this.dateService.convertDateToStringGregorian(date);
  }
}
